var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.978,
    height: 14.336,
    viewBox: "1265.022 459.832 14.978 14.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1271.708 460.33-1.828 3.707-4.09.597a.896.896 0 0 0-.496 1.528l2.96 2.884-.7 4.073a.895.895 0 0 0 1.298.944l3.66-1.924 3.658 1.924c.65.341 1.425-.207 1.3-.944l-.7-4.073 2.959-2.884a.896.896 0 0 0-.496-1.528l-4.09-.597-1.828-3.706c-.328-.66-1.277-.67-1.607 0Z",
    fill: "#595f72",
    fillRule: "evenodd",
    "data-name": "Icon awesome-star"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.6ab7bc487cfc725b60669d977385b5b7.svg";
export { ForwardRef as ReactComponent };